const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  blue: { bg: 'bg-blue-50 dark:bg-blue-900/20', text: 'text-blue-700 dark:text-blue-300', iconBg: 'bg-blue-100 dark:bg-blue-800/40' },
  green: { bg: 'bg-green-50 dark:bg-green-900/20', text: 'text-green-700 dark:text-green-300', iconBg: 'bg-green-100 dark:bg-green-800/40' },
  purple: { bg: 'bg-purple-50 dark:bg-purple-900/20', text: 'text-purple-700 dark:text-purple-300', iconBg: 'bg-purple-100 dark:bg-purple-800/40' },
  orange: { bg: 'bg-orange-50 dark:bg-orange-900/20', text: 'text-orange-700 dark:text-orange-300', iconBg: 'bg-orange-100 dark:bg-orange-800/40' },
  red: { bg: 'bg-red-50 dark:bg-red-900/20', text: 'text-red-700 dark:text-red-300', iconBg: 'bg-red-100 dark:bg-red-800/40' },
  yellow: { bg: 'bg-yellow-50 dark:bg-yellow-900/20', text: 'text-yellow-700 dark:text-yellow-300', iconBg: 'bg-yellow-100 dark:bg-yellow-800/40' },
};

interface GBMStatCardProps {
  label: string;
  value: string | number;
  change?: string;
  color?: keyof typeof colorMap;
  icon?: string;
  action?: React.ReactNode;
}

export default function GBMStatCard({
  label,
  value,
  change,
  color = 'blue',
  icon = 'ri-global-line',
  action,
}: GBMStatCardProps) {
  const c = colorMap[color] || colorMap.blue;
  return (
    <div className={`${c.bg} rounded-lg p-5`}>
      <div className="flex items-center gap-2 mb-2">
        <div className={`${c.iconBg} ${c.text} w-8 h-8 rounded-md flex items-center justify-center`}>
          <i className={`${icon} text-sm`}></i>
        </div>
        <span className={`text-sm font-medium ${c.text}`}>{label}</span>
      </div>
      <div className={`text-2xl font-bold ${c.text}`}>{value}</div>
      {change && <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{change}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}